import React from "react";
import styled from "styled-components";

export default function ScoreRuleTimeInput(props) {
  const { 
    index, 
    value, 
    setValue, 
    placeholder, 
    division, 
    isEdit,
    isUseTimeCap
  } = props;

	function handleChange(e) {
    let input = e.target.value.replace(/[^0-9]/g, ''); // 숫자만 허용

    // 맨 앞의 0 제거 (단, 전체 값이 "0"이면 유지)
    if (input.length > 1) {
      input = input.replace(/^0+/, '');
    }
  
    let limited = input;
  
    if (division === 'MIN') {
      // 분: 최대 3자리
      limited = input.slice(0, 3);
    } else if (division === 'SEC') {
      // 초: 0~59까지만 허용
      if (input.length > 2) input = input.slice(0, 2);
      const num = parseInt(input, 10);
      if (!isNaN(num)) {
        limited = num > 59 ? '59' : input;
      } else {
        limited = '';
      }
    }
    
    setValue(limited, index);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView isUseTimeCap={isUseTimeCap} border={isEdit && isUseTimeCap ? '2px dashed #909090' : '2px solid #909090'}>
      {
        isUseTimeCap ?
          <Input
            placeholder={placeholder}
            value={value}
            type='text'
            disabled={!isEdit}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur} />
          :
          <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' cursor='default'>MAX</Text>
      }
      <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' cursor='default'>{division}</Text>
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 7px 15px;

  width: calc(100% - 32px);

  border: ${props => props.border};
  border-radius: 30px;
  // background-color: ${props => props.isUseTimeCap ? `#2F2F32` : `#020202`};
  background-color: #2F2F32;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 17px;

	width: 80%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #FFFFFF;

  border: none;
  background-color: #2F2F32;

	::placeholder {
		color: #6A6A6C;
	}
  
  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
